<template>
  <div class="main-content">
    <head-top></head-top>
    <router-view />
    <foot-bottom></foot-bottom>
  </div>
</template>

<script setup>
import headTop from './layout/head-top.vue'
import footBottom from './layout/foot-bottom.vue'
import { useI18nStore } from '@/store/index'
import { useI18n } from 'vue-i18n'

const i18nStore = useI18nStore()
const { locale } = useI18n()

//初始化语言
locale.value = i18nStore.locale
i18nStore.toggleLanguage(locale.value)


</script>

<style lang="scss">
@import "@/styles/main.scss";
</style>
